import { Result } from "./common";

export interface MenuItem {
  micuid: number;
  micName: string;
  micGuestDescription: string;
  mttName: string;
  ilcdate: Date;
}

export interface MenuItemList {
  Result: Result;
  DaysMenuList: MenuItem[];
}

export interface DaysMenuResponse {
  GetDaysMenu: MenuItemList;
}

export class DaysMenuRequestBody {
  shpId?: number;
  menudate: string;

  constructor(shpId: number | undefined, menudate: string) {
    this.shpId = shpId;
    this.menudate = menudate;
  }
}